
import { defineComponent, reactive, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import mAxiosApi from "@/api";
import * as moment from "moment";
import { useI18n } from "vue-i18n";
import { setFormatDateLang } from "@/App.vue";

export default defineComponent({
  name: "kt-user-menu",
  components: {},
  setup() {
    const router = useRouter();
    const store = useStore();
    const i18n = useI18n();
    const frNav = ["fr", "fr-FR", "fr-BE", "fr-CA", "fr-LU", "fr-CH", "fr-MC", "fr-MC"]

    const state = reactive({
      initialContact: "",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      contact: {} as any,
      language: getLanguage(),
    });

    function varState() {
      if (!store.getters.isUserAuthenticated) return false;
      state.contact = store.getters.currentUser;
      state.initialContact =
        (state.contact.uti_c_prenom ? state.contact.uti_c_prenom.charAt(0) : "") +
        (state.contact.uti_c_nom ? state.contact.uti_c_nom.charAt(0) : "");
    }

    watch(
      () => store.getters.currentUser,
      function () {
        varState();
      }
    );

    if (!store.getters.isUserAuthenticated) {
      // router.push({ name: "sign-in" });
    } else {
      varState();
    }

    const signOut = () => {

      // console.log('Code ARKKKK', store.getters.currentUser.refCodeArk );

      const refCodeArk = store.getters.currentUser.refCodeArk;

      mAxiosApi.post("/logout");
      store
        .dispatch(Actions.LOGOUT)
        .then(() => { 
          //console.log(refCodeArk);         
          router.push({ name: "sign-in", params: { 'codeArk': refCodeArk } }) 
        } );
    };

    const changeLang = () => {
      let newLang
      if (state.language === "fr") {
        setFormatDateLang("YYYY-MM-DD")
        newLang = "en"
      }else{
        setFormatDateLang("DD.MM.YYYY")
        newLang = "fr"
      }
      localStorage.setItem("language", newLang)
      i18n.locale.value = newLang
      moment.default.locale(newLang)
      setLanguageBack(newLang)
      state.language = newLang
    }

    function getLanguage() {
      if (localStorage.getItem("language")) {
        return localStorage.getItem("language")
      }else{
        if (frNav.indexOf(navigator.language) !== -1) {
          return "fr"
        }else{
          return "en"
        }
      }
    }

    async function setLanguageBack(language): Promise<any> {
      const response = await mAxiosApi.get("/setLanguage/" + language);
    }

    return {
      signOut,
      state,
      changeLang,
    };
  },
});
